export const JMIX_REPORTS_PATH = "/reports";
